module.exports = __webpack_public_path__ + "static/media/google-icon.c5a0e5b7.png";